"use strict";
// .forEach does not work on document.querySelectorAll
// The array returned is not a real array, but a node list
// This requires a custom for each loop
Object.defineProperty(exports, "__esModule", { value: true });
function customForEach(nodeListArray, callback, scope) {
    for (var i = 0; i < nodeListArray.length; i++) {
        callback.call(scope, i, nodeListArray[i]);
    }
}
var QuerySelectorAllForEach = {
    bySelector: function (selector, callback, scope) {
        var nodeListArray = document.querySelectorAll(selector);
        customForEach(nodeListArray, callback, scope);
    },
    byNodeList: function (nodeListArray, callback, scope) {
        customForEach(nodeListArray, callback, scope);
    },
};
exports.default = QuerySelectorAllForEach;
//# sourceMappingURL=query_selector_all_for_each.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/query_selector_all_for_each.js
// module id = 7BnT
// module chunks = 20 21